<template>
<div class="main-area py-4">
          <div class="md:px-8 md:pt-8 form-design-color" id="alert_image_overlay">
            <div class="text-center pt-8 md:pt-0 signup-selection-header pb-4">
                User Registration
            </div>
            <div class="flex login-selection-content w-full justify-evenly">
              <div v-if="!isBuyer" style="cursor:pointer;" @click="isFreelancerSelected(false, true)" class="buyer-selection w-45p md:w-2/5">
                <div class="flex items-center justify-center">
                  <img  class="p-2"  src="@/assets/images/buyer-unhg.png">
                </div>
                <div>
                  <div class="selection-content-text text-center">
                    I'm a Buyer
                  </div>
                  <div class="checkbox_image_overlay">
                    <img  class="checkbox_image"  src="../../../assets/images/buyer-uncheck.png">
                  </div>
                </div>
              </div>
              <div v-if="isBuyer" style="cursor:pointer;" @click="isFreelancerSelected(false, true)" class="buyer-selection buyer-checked w-45p md:w-2/5">
                <div class="flex items-center justify-center">
                  <img  class="p-2"  src="@/assets/images/buyer-hg.png">
                </div>
                <div>
                  <div class="selection-content-text highlighted-text text-center">
                    I'm a Buyer
                  </div>
                  <div class="checkbox_image_overlay">
                    <img  class="checkbox_image"  src="../../../assets/images/buyer-checkbox.png">
                  </div>
                </div>
              </div>
              <div v-if="isFreelancer" style="cursor:pointer;" @click="isFreelancerSelected(true, false)" class="freelancer-selection freelancer-checked w-45p md:w-2/5 bg-white">
                <div class="flex items-center justify-center ">
                  <img  class="p-2"  src="@/assets/images/freelancer-hg.jpg">
                </div>
                <div>
                  <div class="selection-content-text highlighted-text text-center">
                    I'm a Sourcing Expert
                  </div>
                  <div class="checkbox_image_overlay">
                    <img class="checkbox_image_src"  src="../../../assets/images/freelancer-checkbox.png">
                  </div>
                </div>
              </div>
              <div v-if="!isFreelancer" style="cursor:pointer;" @click="isFreelancerSelected(true, false)" class="freelancer-selection w-45p md:w-2/5">
                <div class="flex items-center justify-center ">
                  <img  class="p-2"  src="@/assets/images/freelancer-unhg.png">
                </div>
                <div>
                  <div class="selection-content-text text-center">
                    I'm a Sourcing Expert
                  </div>
                  <div class="checkbox_image_overlay">
                    <img class="checkbox_image_src"  src="../../../assets/images/freelancer_uncheck.png">
                  </div>
                </div>
              </div>
            </div>
            <div class="flexbox text-center pt-4 pb-4 md:pt-2 md:pb-2 md:pt-6">
                  <button
                    @click="redirectToRegister()"
                    :class="!isBuyer&&!isFreelancer ?  'disable-btn' : 'bg-theme'"
                    class="new-app-btn bg-theme mt-6 sm:mt-0"
                    :disabled="!isBuyer&&!isFreelancer">
                    Create an account
                  </button>
            </div>
            <div class="flexbox text-center py-4 dont-have-account">
              Already have an account? <a
                @click="loginPopup()"
                class="underline text-green cursor-pointer"
              >Sign In here! </a>
            </div>
        </div>
</div>
</template>

<script>
import {mapActions} from 'vuex';
export default {
  name: 'SignupSelection',
  beforeRouteEnter: async (to, from, next) => {
    document.title = 'User Registration',
    next()
  },
  data() {
    return{
      isFreelancer : false,
      isBuyer: false
    }
  },
  methods: {
    ...mapActions ([ 'openSignupSelectionModal', 'openLoginSelectionModal', 'LoginSelectionMode' ]),
    isFreelancerSelected(freelancer, buyer) {
      this.isFreelancer = freelancer
      this.isBuyer = buyer
    },
    closeSignupSelectionModal() {
      this.openSignupSelectionModal(false)
    },
    redirectToRegister() {
      if(this.isBuyer || this.isFreelancer) {
        if(this.isBuyer) {
          window.location = `${process.env.VUE_APP_BUYER_HOME_PATH}/register`
        } else {
          window.location = `${process.env.VUE_APP_FREELANCER_HOME_PATH}/register`
        }
      }
    },
    loginPopup() {
      if(this.isBuyer)  {
        this.LoginSelectionMode('buyer')
        this.$router.push({name: 'Login'})
      } else if (this.isFreelancer) {
        this.LoginSelectionMode('freelancer')
        this.$router.push({name: 'Login'})
      } else {
        this.$router.push({name: 'LoginSelection'})
      }
      // this.$router.push({name: 'LoginSelection'})
    } 
  }
}
</script>

<style lang="scss" scoped>
// .main-area {
//   background: linear-gradient(180deg, #DCFBFF 0%, #F9FFF0 100%);
// }
.disable-btn {
  background-color: #C4C4C4;
}
.new-app-btn {
  @apply rounded-full px-8 py-3 text-white;
  font-size: 20px;
  line-height: 30px;
  font-weight: 500;
}
  .alert-modal {
    @apply fixed px-5 h-full inset-0 bg-dark z-50 bg-opacity-50 text-base flex  transition-all duration-150 ease-linear;
    .alert-area {
      @apply z-10 m-auto align-middle rounded-lg w-full;
      @screen md { width: 680px; }
      &__content {
        @apply rounded-lg;
        max-height: calc(100vh - 10px);
        overflow: auto;
        &__header {
          box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.15);
          button {
            @apply text-lg font-bold w-1/2 py-2.5;
            @screen md { @apply text-2xl }
          }
        }
        .switch { @apply relative inline-block w-20 h-9; }
        .switch input { @apply h-0 w-0 h-0; }

        .slider {
          @apply absolute cursor-pointer inset-0;
          background-color: #00B3C9;
          -webkit-transition: .4s;
          transition: .4s;
        }

        .slider:before {
          @apply absolute bg-white h-7 w-7;
          
          left: 4px;
          bottom: 4px;
          -webkit-transition: .4s;
          transition: .4s;
        }

        input:checked + .slider { background-color: #8DC63F; }
        input:focus + .slider { box-shadow: 0 0 1px #8DC63F; }
        .slider.round { border-radius: 34px; }
        .slider.round:before { border-radius: 50%; }

        input:checked + .slider:before {
          -webkit-transform: translateX(42px);
          -ms-transform: translateX(42px);
          transform: translateX(42px);
        }
        .info-box {
          @apply pt-5 px-6 pb-2;
          background: rgba(0, 179, 201, 0.2);
          @screen md { @apply px-12 }
        }
      }
    }

    /* width */
    ::-webkit-scrollbar { width: 4px; }

    /* Track */
    ::-webkit-scrollbar-track { background: rgba(35, 31, 32, 0.15); }

    /* Handle */
    ::-webkit-scrollbar-thumb { background: #a0aec0; }
  }
#alert_image_overlay {
  margin: 4em auto;
  width: 40%;
  position: relative;
  color: #024457;
  // z-index: 1001;
   @media (max-width: 768px) {
    width: 85%;
  }
}
.highlighted-text {
  font-weight: 500;
}
.selection-content-text {
  font-weight: 400;
  font-size: 16px;
  line-height: 19.2px;
  padding-top: 4px;
  padding-bottom: 16px;
  @media (max-width: 768px) {
    padding-top: 4px;
    padding-bottom: 14px;
    font-size: 12px;
    line-height: 14.4px;
  }
}
// .highlighted-freelancer {
//   @apply w-full bg-center bg-no-repeat bg-cover;
//   // background-image: url('../../../assets/images/Freelancer_mobile_banner.png');
//   height: 690px;
//   background-image: url('../../../assets/images/freelancer_uncheck.png');
//   // height: 29px;
//   // width: 10%;
// }
.checkbox_image_overlay {
  border-radius: 8px;
  position: relative;
  overflow: visible;
  padding: 1em;
  color: #024457;
  font-family: Arial;
  @media (max-width: 768px) {
    top: 5px;
    padding: 1.15em;
    
  }
  // z-index: 1001;
}
.checkbox_image_overlay .checkbox_image {
  position: absolute;
  right: 8px;
  height: 24px;
  width: 24px;
  top: 0px;
  z-index: 1;
}
.checkbox_image_overlay .checkbox_image_src {
  position: absolute;
  right: 8px;
  height: 24px;
  width: 24px;
  top: 0px;
  z-index: 1;
}
#alert_image_overlay #close {
  position: absolute;
  top: 13px;
  right: 13px;
  
}
#alert_image_overlay #alert_header {
  position: absolute;
  top: 45px;
  left: 40px;
  color: #2D2D84;
  font-size: 60px;
  line-height: 60px;
  font-weight: 600;
  font-style: Avenir;

}
.w-45p {
  @media (min-width: 768px) {
    width: 40%;
  }
  width: 45%;
}
#alert_image_overlay #alert_content {
  position: absolute;
  top: 170px;
  left: 40px;
  color: #243943;
  font-size: 24px;
  line-height: 32.78px;
  font-style: Avenir;
}
#alert_image_overlay #alert_button {
  position: absolute;
  top: 250px;
  left: 40px;
  background-color: #2D2D84;
  color: white;
  font-size: 24px;
  line-height: 40px;
  font-style: Avenir;

}
.buyer-selection {
  border: 1px solid #C4C4C4;
  border-radius: 4px;
}
.dont-have-account {
  @media(max-width: 768px) { 
    font-size: 14px;
    line-height: 14px;
  }
}
.freelancer-checked {
  background: #FFFFFF;
  border: 1px solid #8BC53F !important;
  box-shadow: 1px 1px 6px 1px #C5DFE2;
  border-radius: 4px;
}
.buyer-checked {
  background: #FFFFFF;
  border: 1px solid #00B2C9 !important;
  box-shadow: 1px 1px 6px 1px #C5DFE2;
  border-radius: 4px;
}
.freelancer-selection {
  border: 1px solid #C4C4C4;
  border-radius: 4px;
}
.signup-selection-header {
  @media(max-width: 768px) { 
     font-family: 'Avenir LT Pro';
    font-weight: 500;
    font-size: 24px;
    line-height: 26px;
  }
  
    display: flex;
    justify-content: center;
    color: #00B2C9;
    font-family: 'Avenir LT Pro';
    font-weight: 500;
    font-size: 28px;
    line-height: 38px;
}
.form-design-color{
  background: white;
  border: 1px solid #C4C4C4;
  border-radius: 4px;
}
</style>